
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { memo } from "react";

interface BarChartDataItem {
  name: string;
  fraudulent: number;
  suspicious: number;
  safe: number;
}

interface WeeklyResultsChartProps {
  data: BarChartDataItem[];
}

// Memoized component to prevent unnecessary re-renders
const WeeklyResultsChart = memo(({ data }: WeeklyResultsChartProps) => {
  return (
    <Card className="col-span-2">
      <CardHeader>
        <CardTitle>Weekly Results</CardTitle>
        <CardDescription>Detection results by category</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data}>
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar 
                dataKey="safe" 
                stackId="a" 
                fill="#22C55E" 
                isAnimationActive={false} // Disable animations for better performance
              />
              <Bar 
                dataKey="suspicious" 
                stackId="a" 
                fill="#F59E0B" 
                isAnimationActive={false}
              />
              <Bar 
                dataKey="fraudulent" 
                stackId="a" 
                fill="#EF4444" 
                isAnimationActive={false}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
});

WeeklyResultsChart.displayName = "WeeklyResultsChart";

export default WeeklyResultsChart;
